// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";

function UnorderedListComponent(Props) {
  var list = Props.list;
  return React.createElement("ul", {
              className: "rnr-coupon-list-container"
            }, $$Array.of_list(List.map((function (li) {
                        return React.createElement("li", {
                                    key: li,
                                    className: "list"
                                  }, li);
                      }), list)));
}

var make = UnorderedListComponent;

export {
  make ,
  
}
/* react Not a pure module */
